<template>
    <div class="assembly">
         <div class="m-left"><span></span> 选择组件</div>
         <div class="select">
            <div class="select-item active'">
                <div class="item-img">
                    <img :src="selectList.url" alt="" draggable="true" @dragend="dragend_fn($event)">
                </div>
                <p>{{selectList.name}}</p>
            </div>

         </div>
        <div class="m-left"><span></span> 编辑属性</div>
        
        <div class="style-con">
             <div class="style-item">
                  <span>行数</span>
                  <el-select v-model="rowVal" filterable  placeholder="请选择" style="width:100px;margin-right:12px" @change="change_fn">
                        <el-option
                        v-for="item in rowList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                  
         </div>
        <div class="style-item">
                  <span>告警</span>
                  <el-select v-model="alarmFont" filterable  placeholder="请选择" style="width:100px;margin-right:12px" @change="change_fn">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-color-picker v-model="alarmColor" show-alpha @change="change_fn"></el-color-picker>
         </div>
          <div class="style-item">
                  <span>预警</span>
                  <el-select v-model="warningFont" filterable  placeholder="请选择" style="width:100px;margin-right:12px" @change="change_fn">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-color-picker v-model="warningColor" show-alpha @change="change_fn"></el-color-picker>
         </div>
          <div class="style-item">
                  <span>通知</span>
                  <el-select v-model="noticeFont" filterable  placeholder="请选择" style="width:100px;margin-right:12px" @change="change_fn">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-color-picker v-model="noticeColor" show-alpha @change="change_fn"></el-color-picker>
          </div>
           <div class="style-item">
                  <span>内容</span>
                  <el-select v-model="vlaueCon" filterable  placeholder="请选择" style="width:100px;margin-right:12px" @change="change_fn">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-color-picker v-model="contenColor" show-alpha @change="change_fn"></el-color-picker>
          </div>
          <div class="style-item">
                  <span>时间</span>
                  <el-select v-model="vlaueTime" filterable  placeholder="请选择" style="width:100px;margin-right:12px" @change="change_fn">
                        <el-option
                        v-for="item in fontSizeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-color-picker v-model="timeColor" show-alpha @change="change_fn"></el-color-picker>
          </div>
       
        </div>
       
        
       
        
        
    </div>
</template>

<script>
export default {
    // props:['nowTabulationData'],
     props: {
         nowTabulationData: {
            type: Object,
            default: () => ({})
        },
      
        
        },
    data() {
        return {
            //组件数据
             selectList:{
                  'name':"消息，告警",
                  'url':require('@/assets/customKanBan/kanBanChart/liebiao.png'),
                },
             fontSizeList:[],
             vlaue:"",
             valcolor:"#fff",
             alarmFont:'12px',//告警
             alarmColor:'#ec502e',//告警
             warningFont:'12px',//预警
             warningColor:'#e0832e',//预警
             noticeFont:'12px',//通知
             noticeColor:'#2cac95',//通知

             vlaueCon:"14px",//内容
             contenColor:"#fff",//内容

             vlaueTime:"14px",//时间
             timeColor:"#fff",//时间
             
             rowList:[],//行数
             rowVal:'6'



          
           
        };
    },

    mounted() {
        for(let i = 12 ;i<=20;i++){
           if(i % 2 ==0){
              this.fontSizeList.push({
                label:i,
                value:i + 'px'
              })
           }
        }

        for(let i = 1;i<= 15;i++){
            this.rowList.push({
                label:i,
                value:i
            })
        }
      
    },
    watch:{
      nowTabulationData(val){
          if(JSON.stringify(val) == '{}'){
            return
          }
          var datList = JSON.parse(JSON.stringify(val))
          this.alarmFont = datList.alarm.fontSize
          this.alarmColor = datList.alarm.color
          this.warningFont = datList.warning.fontSize
          this.warningColor = datList.warning.color
          this.noticeFont = datList.notice.fontSize
          this.noticeColor = datList.notice.color
          this.vlaueCon = datList.con.fontSize
          this.contenColor = datList.con.color
          this.vlaueTime = datList.time.fontSize
          this.timeColor = datList.time.color
          this.rowVal = datList.rowVal
        

      }
        
    },

    methods: {
        //拖放
        dragend_fn(e){
           var clientX = e.clientX
            var clientY = e.clientY
            var d  = {
                 'clientX':clientX, 
                 'clientY':clientY,
                    'tabIndex':4,
                    'alarm':{
                        "fontSize":this.alarmFont,
                        "color":this.alarmColor,
                        "borderColor":this.alarmColor,
                    },
                    'warning':{
                        "fontSize":this.warningFont,
                        "color":this.warningColor,
                        "borderColor":this.warningColor,
                    },
                    'notice':{
                        "fontSize":this.noticeFont,
                        "color":this.noticeColor,
                        "borderColor":this.noticeColor,
                    },
                    'con':{
                        "fontSize":this.vlaueCon,
                        "color":this.contenColor,
                    },
                    'time':{
                        "fontSize":this.vlaueTime,
                        "color":this.timeColor,
                    },
                    'rowVal':this.rowVal
                
            }
             this.$emit('tabulation_fn',d)
        },

        //改变

        change_fn(){
             var d  = {
                    'alarm':{
                        "fontSize":this.alarmFont,
                        "color":this.alarmColor,
                        "borderColor":this.alarmColor,
                    },
                    'warning':{
                        "fontSize":this.warningFont,
                        "color":this.warningColor,
                        "borderColor":this.warningColor,
                    },
                    'notice':{
                        "fontSize":this.noticeFont,
                        "color":this.noticeColor,
                        "borderColor":this.noticeColor,
                    },
                    'con':{
                        "fontSize":this.vlaueCon,
                        "color":this.contenColor,
                    },
                    'time':{
                        "fontSize":this.vlaueTime,
                        "color":this.timeColor,
                    },
                    'rowVal':this.rowVal
                
            }
            this.$emit('changtabulation_fn',d)

        }

       


      
        
       
    },
};
</script>

<style lang="scss" scoped>
.assembly{
    .m-left {
        color: #359EFF;
        display: flex;
        align-items: center;
        span {
            background-color: #359EFF;
            display: inline-block;
            width: 2px;
            height: 12px;
            margin-right: 4px;

        }
    }
    .select {
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
       margin-bottom: 40px;
        
        .select-item {
            width: 31%;
            height: 100px;
            background-color: #000000;
            margin-top: 15px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
             transition: all 0.3s;
            border: 2px solid transparent;
            .item-img {
                width: 95%;
                height: 68px;
                margin-top: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    max-width: 95%;
                    height: 100%;
                }

            }
            &.active {
                // border: 2px solid #0085FF;
                border: 2px solid aqua;

            }
     
          &:hover {
				/* 鼠标悬浮时盒子出现的阴影 */
                //    box-shadow: 0px 1px 12px 0px #cccccc;
				transform: translate(0, -5px);/* 鼠标悬浮时盒子上移10px */
			}
            p {
                color: #999999;
            }
        }
    }
      .style-con {
            .style-item {
                
                display: flex;
                align-items: center;
                margin-top: 20px;
               
                span {
                    margin-right: 20px;
                    display: inline-block;
                    width: 30px;
                     text-align: right;
                }
                p {
                    margin-left: 4px;
                    color: #999999;
                }
            }
            /deep/.el-checkbox {
                margin-right: 20px;
                color: #999999;
            }
            /deep/.el-checkbox__label {
                padding-left: 4px;
            }
        }

     .tab-chat {
        // position: relative;
        margin-top: 10px;
        span {
            display: inline-block;
            padding: 0px 8px;
            margin-right: 20px;
            color: #999999;
            height: 24px;
            border-bottom: 2px solid transparent;
            &.active{
                color: #359EFF;
                border-bottom-color: #359EFF;
            }
        }
       
       
    }
    
   



}
</style>